import Swiper, {Pagination, Autoplay, EffectFade, Navigation, Thumbs} from 'swiper';
Swiper.use([Pagination, Autoplay, EffectFade, Navigation, Thumbs]);

function init() {
	const firstSlider = new Swiper('.first__slider', {
		slidesPerView: 1,
		loop: true,
		effect: 'fade',

		// autoplay: {
		// 	delay: 3000,
		// },

		pagination: {
			el: '.first__slider-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	const specialistsSlider = new Swiper('.specialists__slider', {
		slidesPerView: 3,
		loop: true,
		spaceBetween: 20,

		pagination: {
			el: '.specialists__slider-pagination',
			type: 'bullets',
			clickable: true,
		},

		breakpoints: {
			1920: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			1440: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			1024: {
				slidesPerView: 2,
				spaceBetween: 20,
			},

			768: {
				slidesPerView: 2,
				spaceBetween: 21,
			},

			375: {
				slidesPerView: 1,
				spaceBetween: 12,
			},

			320: {
				slidesPerView: 1,
				spaceBetween: 12,
			},
		},
	});

	const licenseSliderThumbs = new Swiper('.licenses__slider-3-thumbs', {
		slidesPerView: 2,
		spaceBetween: 20,
		loop: true,

		breakpoints: {
			360: {
				slidesPerView: 2,
				spaceBetween: 20,
			},

			375: {
				slidesPerView: 2,
				spaceBetween: 20,
			},

			320: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
		},
	});

	const sertificatSlider = new Swiper('.licenses__slider-3', {
		slidesPerView: 3,
		loop: true,
		spaceBetween: 120,
		centeredSlides: true,

		navigation: {
			prevEl: '.licenses__slider-3-prev',
			nextEl: '.licenses__slider-3-next',
		},

		pagination: {
			el: '.licenses__slider-3-pagination',
			clickable: true,
		},

		thumbs: {
			swiper: licenseSliderThumbs,
		},

		breakpoints: {
			1920: {
				slidesPerView: 3,
				spaceBetween: 50,
			},

			1440: {
				slidesPerView: 3,
				spaceBetween: 50,
			},

			1024: {
				slidesPerView: 3,
				spaceBetween: 37,
			},

			1000: {
				slidesPerView: 3,
				spaceBetween: 37,
			},

			768: {
				slidesPerView: 3,
				spaceBetween: 20,
				centeredSlides: true,
			},

			360: {
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: false,
			},

			375: {
				slidesPerView: 1,
				spaceBetween: 20,
				centeredSlides: false,
			},

			320: {
				slidesPerView: 1,
				spaceBetween: 12,
			},
		},

	});

	const licenseSlider = new Swiper('.licenses__slider', {
		slidesPerView: 3,
		loop: true,
		spaceBetween: 120,
		centeredSlides: true,

		navigation: {
			prevEl: '.licenses__slider-prev',
			nextEl: '.licenses__slider-next',
		},

		pagination: {
			el: '.licenses__slider-pagination',
			clickable: true,
		},

		breakpoints: {
			1920: {
				slidesPerView: 3,
				spaceBetween: 50,
			},

			1440: {
				slidesPerView: 3,
				spaceBetween: 50,
			},

			1024: {
				slidesPerView: 3,
				spaceBetween: 37,
			},

			1000: {
				slidesPerView: 3,
				spaceBetween: 37,
			},

			768: {
				slidesPerView: 3,
				spaceBetween: 20,
				centeredSlides: true,
			},

			360: {
				slidesPerView: 2,
				spaceBetween: 20,
				centeredSlides: false,
			},

			375: {
				slidesPerView: 2,
				spaceBetween: 20,
				centeredSlides: false,
			},

			320: {
				slidesPerView: 1,
				spaceBetween: 12,
			},
		},

	});

	const licenseSliderTwo = new Swiper('.licenses__slider-2', {
		slidesPerView: 3,
		speed: 600,

		fadeEffect: {
			crossFade: true,
		},

		breakpoints: {
			360: {
				slidesPerView: 2,
				spaceBetween: 20,
			},

			375: {
				slidesPerView: 2,
				spaceBetween: 20,
			},

			320: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
		},

	});

	const visitorsSliderThumbs = new Swiper('.visitors__slider-thumbs', {
		slidesPerView: 5,
		spaceBetween: 30,
		loop: true,

		navigation: {
			prevEl: '.visitors__slider-thumbs-prev',
			nextEl: '.visitors__slider-thumbs-next',
		},

		breakpoints: {
			1920: {
				slidesPerView: 5,
				spaceBetween: 29,
			},

			1440: {
				slidesPerView: 5,
				spaceBetween: 29,
			},

			1024: {
				slidesPerView: 4,
				spaceBetween: 29,
			},

			1000: {
				slidesPerView: 4,
				spaceBetween: 29,
			},

			360: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			375: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			320: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
		},

	});

	const visitorsSlider = new Swiper('.visitors__slider', {
		slidesPerView: 1,
		loop: true,

		thumbs: {
			swiper: visitorsSliderThumbs,
		},
	});

	const eventsSliderThumbs = new Swiper('.events__slider-thumbs', {
		slidesPerView: 5,
		spaceBetween: 30,
		loop: true,

		navigation: {
			prevEl: '.events__slider-thumbs-prev',
			nextEl: '.events__slider-thumbs-next',
		},

		breakpoints: {
			1920: {
				slidesPerView: 5,
				spaceBetween: 29,
			},

			1440: {
				slidesPerView: 5,
				spaceBetween: 29,
			},

			1024: {
				slidesPerView: 4,
				spaceBetween: 29,
			},

			1000: {
				slidesPerView: 4,
				spaceBetween: 29,
			},

			360: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			375: {
				slidesPerView: 3,
				spaceBetween: 20,
			},

			320: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
		},
	});

	const eventsSlider = new Swiper('.events__slider', {
		slidesPerView: 1,
		loop: true,

		thumbs: {
			swiper: eventsSliderThumbs,
		},
	});

	const newsSlider = new Swiper('.news__slider', {
		slidesPerView: 1,
		effect: 'fade',
		loop: true,
		centeredSlides: true,

		navigation: {
			prevEl: '.news__slider-prev',
			nextEl: '.news__slider-next',
		},

		pagination: {
			el: '.news__slider-pagination',
			clickable: true,
		},
	});
}

export default {
	init,
};
